import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { useBox } from "../../../Finanzas/Helper/useBox";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FiltroPostventaCotizaciones from "./FiltroPostventaCotizaciones";
import AgregarContactoCotizacionesModal from "./AgregarContactoCotizacionesModal";
import CommentIcon from "@mui/icons-material/Comment";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EditIcon from "@mui/icons-material/Edit";
import { ModalComentariosTimeline } from "./ModalComentariosTimeline";
import ModalOrden from "./ModalOrden";
import FiltroMultiple from "../Modales/FiltroMultiple";
import { ChatScreen } from "../../../Whatsapp/ChatScreen";
import { esTelefonoValido } from "../Helpers/esTelefonoValido";
import { TextField } from "@mui/material";

export const CotizacionesDashboardMainScreen = () => {
  const history = useHistory();
  const location = useLocation();
  const [boxstate, setBoxState] = useBox();
  const [cotizacionesAbiertas, setCotizacionesAbiertas] = useState();
  const [cotizacionesAbiertasArray, setCotizacionesAbiertasArray] = useState();
  const [clienteSelect, setClienteSelect] = useState();
  const [folioSelect, setFolioSelect] = useState();
  const [openModalComentarios, setOpenModalComentarios] = useState(false);
  const [folioSelected, setFolioSelected] = useState("");
  const [fechaRecordatorio, setFechaRecordatorio] = useState("");
  const [openModalContacto, setOpenModalContacto] = useState(false);
  const [titulo, setTitulo] = useState("COTIZACIONES DE REFACCIONES");

  //States whatsapp
  const [modalChat, setModalChat] = useState(false);
  const [telefonoContacto, setTelefonoContacto] = useState("");

  //Modal de ordenes de cotizacion
  const [folio, setFolio] = useState(0);
  const [cliente, setCliente] = useState("");
  const [mortrarOrden, setMostrarOrden] = useState(false);

  //Totales
  // const [totalCotizacion, setTotalCotizacion] = useState(0);
  const [totalMensajes, setTotalMensajes] = useState(0);

  const [predictivo, setPredictivo] = useState("");

  // filtros en tabla
  const [options, setOptions] = useState({
    estatus: [],
    mensajes: [],
    facturado: [],
    contacto: [],
  });
  const [filtros, setFiltros] = useState({
    estatus: [],
    mensajes: [],
    facturado: [],
    contacto: [],
  });
  const [prioridadFiltros, setPrioridadFiltros] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [filtrosTemp, setFiltrosTemp] = useState({
    estatus: [],
    mensajes: [],
    facturado: [],
    contacto: [],
  });

  const [mostrarFiltro, setMostrarFiltro] = useState({
    contacto: { open: false },
    estatus: { open: false },
    mensajes: { open: false },
    facturado: { open: false },
  });

  const {
    sucursales,
    adr,
    ejercicio_inicio,
    ejercicio_fin,
    periodo_inicio,
    periodo_fin,
    estatus,
    motivo,
    filtroSucursales,
  } = location.state || {};

  const meses = [
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];

  const actualizarPrioridad = (filtro) => {
    setPrioridadFiltros((prev) => {
      const index = prev.indexOf(filtro);

      let nuevasPrioridades;

      // nuevo filtro → se agrega
      if (index === -1) {
        nuevasPrioridades = [...prev, filtro];
      }
      // filtro existente → se cortan los posteriores
      else {
        nuevasPrioridades = prev.slice(0, index + 1);
      }

      // 🔥 LIMPIAR filtros que perdieron prioridad
      setFiltrosTemp((prevTemp) => {
        const limpio = { ...prevTemp };

        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) {
            limpio[key] = [];
          }
        });

        return limpio;
      });

      // 🔥 LIMPIAR filtros aplicados también
      setFiltros((prevFiltros) => {
        const limpio = { ...prevFiltros };

        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) {
            limpio[key] = [];
          }
        });

        return limpio;
      });

      return nuevasPrioridades;
    });
  };

  const aplicarFiltros = (data, filtros, _, filtrosPermitidos = []) => {
    let resultado = [...data];

    filtrosPermitidos.forEach((filtro) => {
      if (filtro === "estatus" && filtros.estatus.length > 0) {
        resultado = resultado.filter((i) => filtros.estatus.includes(i.estado));
      }

      if (filtro === "mensajes" && filtros.mensajes.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.mensajes.includes(i.mensajes_enviados),
        );
      }

      if (filtro === "facturado" && filtros.facturado.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.facturado.includes(i.facturado),
        );
      }

      if (filtro === "contacto" && filtros.contacto.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.contacto.includes(i.whatsapp !== "Sin registrar" ? "S" : "N"),
        );
      }
    });

    return resultado;
  };

  //Actualizacion de datos dependiendo filtros
  useEffect(() => {
    if (!Array.isArray(cotizacionesAbiertasArray)) return;

    let data = [...cotizacionesAbiertasArray];

    // 🔍 PREDICTIVO (PRIMERO)
    if (predictivo) {
      data = data.filter((item) =>
        item.cliente.toUpperCase().includes(predictivo.toUpperCase())
      );
    }

    // 🔥 FILTROS POR PRIORIDAD
    prioridadFiltros.forEach((filtro) => {
      switch (filtro) {
        case "estatus":
          if (filtros.estatus.length > 0) {
            data = data.filter((i) => filtros.estatus.includes(i.estado));
          }
          break;

        case "mensajes":
          if (filtros.mensajes.length > 0) {
            data = data.filter((i) =>
              filtros.mensajes.includes(i.mensajes_enviados)
            );
          }
          break;

        case "facturado":
          if (filtros.facturado.length > 0) {
            data = data.filter((i) =>
              filtros.facturado.includes(i.facturado)
            );
          }
          break;

        case "contacto":
          if (filtros.contacto.length > 0) {
            data = data.filter((i) =>
              filtros.contacto.includes(
                i.whatsapp !== "Sin registrar" ? "S" : "N"
              )
            );
          }
          break;

        default:
          break;
      }
    });

    setDatosFiltrados(data);
  }, [cotizacionesAbiertasArray, filtros, prioridadFiltros, predictivo]);

  //Esquema de filtrado en tabla
  useEffect(() => {
    if (!Array.isArray(cotizacionesAbiertasArray)) return;

    const getBaseData = (filtro) => {
      const index = prioridadFiltros.indexOf(filtro);

      // Si el filtro NO ha sido usado aún → usar data filtrada actual
      if (index === -1) {
        return aplicarFiltros(
          cotizacionesAbiertasArray,
          filtros,
          null,
          prioridadFiltros,
        );
      }

      // Si es el primero → data completa
      if (index === 0) {
        return cotizacionesAbiertasArray;
      }

      // Solo aplicar filtros con MAYOR prioridad
      const filtrosPrevios = prioridadFiltros.slice(0, index);

      return aplicarFiltros(
        cotizacionesAbiertasArray,
        filtros,
        null,
        filtrosPrevios,
      );
    };

    // ESTATUS
    const estatusOptions = [
      ...new Set(getBaseData("estatus").map((i) => i.estado)),
    ].map((v) => ({ value: v, label: v }));

    // MENSAJES
    const mensajesOptions = [
      ...new Set(getBaseData("mensajes").map((i) => i.mensajes_enviados)),
    ].map((v) => ({
      value: v,
      label:
        v === 0
          ? "Pendiente"
          : v === 1
            ? "Recordatorio 1"
            : v === 2
              ? "Recordatorio 2"
              : v === 3
                ? "Recordatorio 3"
                : "Desconocido",
    }));

    // FACTURADO
    const facturadoOptions = [
      ...new Set(getBaseData("facturado").map((i) => i.facturado)),
    ].map((v) => ({
      value: v,
      label: v === "S" ? "Si" : "No",
    }));

    // Contacto
    const contactoBase = getBaseData("contacto");

    const tieneContacto = contactoBase.some(
      (i) => i.whatsapp !== "Sin registrar",
    );
    const sinContacto = contactoBase.some(
      (i) => i.whatsapp === "Sin registrar",
    );

    const contactoOptions = [
      ...(tieneContacto ? [{ value: "S", label: "Sí" }] : []),
      ...(sinContacto ? [{ value: "N", label: "No" }] : []),
    ];

    setOptions({
      estatus: estatusOptions,
      mensajes: mensajesOptions,
      facturado: facturadoOptions,
      contacto: contactoOptions,
    });
  }, [cotizacionesAbiertasArray, filtros, prioridadFiltros]);

  const limpiarFiltros = () => {
    setFiltros({
      estatus: [],
      mensajes: [],
      facturado: [],
      contacto: [],
    });

    setFiltrosTemp({
      estatus: [],
      mensajes: [],
      facturado: [],
      contacto: [],
    });

    setPrioridadFiltros([]);
    setDatosFiltrados([]);
  };

  const handleOpenModalContacto = (idcliente, folio) => {
    if (!idcliente) {
      idcliente = -99;
    }

    setClienteSelect(idcliente);
    setFolioSelect(folio);
    setOpenModalContacto(true);
  };

  const handleCloseModalContacto = () => {
    setClienteSelect("");
    setFolioSelect("");
    setOpenModalContacto(false);
  };

  // const currentDate = new Date();
  // const anioActual = currentDate.getFullYear();
  // const mesActual = currentDate.getMonth() + 1;
  useEffect(() => {
    setBoxState("pv", {
      adr: filtroSucursales.adr,
      sucursal: filtroSucursales.sucursal,
      departamento: filtroSucursales.departamento,
    });
  }, []);
  // console.log(boxstate)
  useEffect(() => {
    if (openModalContacto === true) return;

    onIniciar(
      ejercicio_inicio,
      ejercicio_fin,
      periodo_inicio,
      periodo_fin,
      boxstate.whatsapp,
      "C",
      estatus,
      motivo,
      sucursales,
      adr,
    );
  }, [openModalContacto]);

  const onUpdate = () => {
    onIniciar(
      ejercicio_inicio,
      ejercicio_fin,
      periodo_inicio,
      periodo_fin,
      boxstate.whatsapp,
      "C",
      estatus,
      motivo,
      sucursales,
      adr,
    );
  };
  const onIniciar = (
    ejercicio_inicio,
    ejercicio_fin,
    periodo_inicio,
    periodo_fin,
    whatsapp,
    facturado,
    estatus,
    motivo,
    filtroSucursales,
    filtoAdr,
  ) => {
    setLoader({ ...loader, mostrar: true });
    var sucursalesEnviar = filtroSucursales;
    var adrEnviar = filtoAdr;

    var p_fin = "";
    if (
      filtroSucursales === undefined ||
      filtroSucursales === null ||
      filtroSucursales === ""
    ) {
      sucursalesEnviar = "0";
    }
    if (filtoAdr === undefined || filtoAdr === null || filtoAdr === "") {
      adrEnviar = "0";
    }
    if (
      periodo_fin === undefined ||
      periodo_fin === null ||
      periodo_fin === "" ||
      periodo_fin === "0"
    ) {
      p_fin = periodo_inicio;
    } else {
      p_fin = periodo_fin;
    }

    if (
      Number(p_fin) < Number(periodo_inicio) &&
      Number(ejercicio_fin) < Number(ejercicio_inicio)
    ) {
      Swal.fire(
        "DASHBOARD",
        "La fecha de inicio no puede ser menor a la final",
        "warning",
      );
      return;
    }

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `DashboardPostventa/CotizacionesAbiertas?ejercicio_inicio=${ejercicio_inicio}&ejercicio_fin=${ejercicio_fin}&periodo_inicio=${periodo_inicio}&periodo_fin=${p_fin}&facturado=${facturado}&whatsapp=${whatsapp}&estado=${estatus}&motivo=${motivo}&adr=${adrEnviar}&sucursal=${sucursalesEnviar}`,
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setCotizacionesAbiertas(result);
          setCotizacionesAbiertasArray(result);
          const mesInicio = meses[periodo_inicio - 1];
          const mesFin = meses[p_fin - 1];

          let tituloP = "COTIZACIONES DE REFACCIONES ";

          // 1️⃣ Mes diferente y ejercicio diferente
          if (mesInicio !== mesFin && ejercicio_inicio !== ejercicio_fin) {
            tituloP += `${mesInicio} ${ejercicio_inicio} - ${mesFin} ${ejercicio_fin}`;
          }
          // 2️⃣ Mismo mes y ejercicio diferente
          else if (mesInicio === mesFin && ejercicio_inicio !== ejercicio_fin) {
            tituloP += `${mesInicio} ${ejercicio_inicio} - ${ejercicio_fin}`;
          }
          // 3️⃣ Mes diferente y mismo ejercicio
          else if (mesInicio !== mesFin && ejercicio_inicio === ejercicio_fin) {
            tituloP += `${mesInicio} - ${mesFin} ${ejercicio_inicio}`;
          }
          // 4️⃣ Mismo mes y mismo ejercicio
          else {
            tituloP += `${mesInicio} - ${ejercicio_inicio}`;
          }

          setTitulo(tituloP);

          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  const onExecute = (
    ejercicio_inicio,
    ejercicio_fin,
    periodo_inicio,
    periodo_fin,
    facturado,
    whatsapp,
    estatus,
    motivo,
  ) => {
    setLoader({ ...loader, mostrar: true });
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    var p_fin = "";
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (
      periodo_fin === undefined ||
      periodo_fin === null ||
      periodo_fin === "" ||
      periodo_fin === "0"
    ) {
      p_fin = periodo_inicio;
    } else {
      p_fin = periodo_fin;
    }

    if (
      motivo === undefined ||
      motivo === null ||
      motivo === ""
    ) {
      motivo = "CC";
    }

    if (
      Number(p_fin) < Number(periodo_inicio) &&
      Number(ejercicio_fin) < Number(ejercicio_inicio)
    ) {
      Swal.fire(
        "DASHBOARD",
        "La fecha de inicio no puede ser menor a la final",
        "warning",
      );
      setLoader({ ...loader, mostrar: false });
      return;
    }

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `DashboardPostventa/CotizacionesAbiertas?ejercicio_inicio=${ejercicio_inicio}&ejercicio_fin=${ejercicio_fin}&periodo_inicio=${periodo_inicio}&periodo_fin=${p_fin}&facturado=${facturado}&whatsapp=${whatsapp}&estado=${estatus}&motivo=${motivo}&adr=${adr}&sucursal=${sucursales}`,
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setCotizacionesAbiertas(result);
          setCotizacionesAbiertasArray(result);
          console.log(result);

          // const tituloP = `COTIZACIONES DE REFACCIONES ${Number(periodo_inicio) === Number(p_fin) ? "" : "- " + meses[periodo_inicio - 1]} - ${meses[p_fin - 1]} ${ejercicio}`
          const mesInicio = meses[periodo_inicio - 1];
          const mesFin = meses[p_fin - 1];

          let tituloP = "COTIZACIONES DE REFACCIONES ";

          // 1️⃣ Mes diferente y ejercicio diferente
          if (mesInicio !== mesFin && ejercicio_inicio !== ejercicio_fin) {
            tituloP += `${mesInicio} ${ejercicio_inicio} - ${mesFin} ${ejercicio_fin}`;
          }
          // 2️⃣ Mismo mes y ejercicio diferente
          else if (mesInicio === mesFin && ejercicio_inicio !== ejercicio_fin) {
            tituloP += `${mesInicio} ${ejercicio_inicio} - ${ejercicio_fin}`;
          }
          // 3️⃣ Mes diferente y mismo ejercicio
          else if (mesInicio !== mesFin && ejercicio_inicio === ejercicio_fin) {
            tituloP += `${mesInicio} - ${mesFin} ${ejercicio_inicio}`;
          }
          // 4️⃣ Mismo mes y mismo ejercicio
          else {
            tituloP += `${mesInicio} - ${ejercicio_inicio}`;
          }

          setTitulo(tituloP);

          limpiarFiltros();
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  const onRegresar = (estatus, motivo) => {
    history.push("/PostVenta/Dashboard", {
      sucursales: sucursales,
      adr: adr,
      ejercicio_inicio: ejercicio_inicio,
      ejercicio_fin: ejercicio_fin,
      periodo_inicio: periodo_inicio,
      periodo_fin: periodo_fin,
      filtroSucursales,
      regresar: true,
    });
  };

  const handleOpenModalComentarios = (folio, fecha) => {
    setFolioSelected(folio);
    setFechaRecordatorio(fecha);
    setOpenModalComentarios(true);
  };

  const handleCloseModalComentarios = () => {
    setOpenModalComentarios(false);
    // if (actualizarLista) actualizarLista();
  };

  const onVerOrden = (folio, cliente, tieneOrden) => {
    if (tieneOrden === "N") {
      return;
    } else {
      setFolio(folio);
      setCliente(cliente);
      setMostrarOrden(true);
    }
  };

  //Chat whatsapp
  const handleOpenModalChat = (numero, cliente) => {
    setTelefonoContacto(numero);
    setCliente(cliente);
    setModalChat(true);
  };

  const handleCloseModalChat = () => {
    setTelefonoContacto("");
    setCliente("");
    setModalChat(false);
  };

  //predicitivo
  // useEffect(() => {
  //     const result = cotizacionesAbiertasArray?.filter((item) =>
  //       item.cliente.toUpperCase().includes(predictivo.toUpperCase())
  //     );
  //     setCotizacionesAbiertas(result);
  //   }, [predictivo]);

  const totalCotizacion =
    datosFiltrados?.reduce((acc, item) => acc + (Number(item.total) || 0), 0) ??
    0;

  return (
    <PlantillaScreen
      titulo={titulo}
      className={"cotizaciones-ref-main-screen"}
      className_main={2}
    >
      <AgregarContactoCotizacionesModal
        open={openModalContacto}
        onClose={handleCloseModalContacto}
        idcliente={clienteSelect}
        folio={folioSelect}
      />
      <ModalOrden
        folio={folio}
        cliente={cliente}
        onClose={() => setMostrarOrden(false)}
        open={mortrarOrden}
      />
      <LoaderScreen loader={loader} />
      <div className="cotizaciones-ref-actions">
        <div
          className="cotizaciones-ref-actions-regresar"
          onClick={() => onRegresar()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="cotizaciones-ref-actions-filtro">
          <FiltroPostventaCotizaciones
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
            mostrarestatus={true}
            mostrarwhatsapp={true}
            mostrarmotivo={true}
            ejercicio_inicio={ejercicio_inicio}
            ejercicio_fin={ejercicio_fin}
            periodo_inicio={periodo_inicio}
            periodo_fin={periodo_fin}
            sucursalesEncontrados={sucursales}
            adrEncontrados={adr}
            estatusEncontrado={estatus}
            motivoEncontrado={motivo}
            filtroSucursales={filtroSucursales}
            dashboard={true}
          />
        </div>
      </div>


      <div className="cotizaciones-ref">
        <div className="cotizaciones-ref-header">
          <div className="cotizaciones-ref-header-control">
            <TextField
              color="success"
              fullWidth
              size="small"
              value={predictivo}
              onChange={({ target }) => setPredictivo(target.value)}
              placeholder="Buscar Cliente..."
            />
          </div>
        </div>
        <div className="cotizaciones-ref-container scroll">
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th className="sticky-chat-whatsapp"></th>
                <th className="sticky-folio">Folio</th>
                <th className="sticky-cliente">
                  <div>Cliente</div>
                </th>
                <th>
                  <div>Sucursal</div>
                </th>
                <th>
                  <div>Vendedor</div>
                </th>
                <th>
                  <div>Responsable</div>
                </th>
                <th>
                  <div>Fecha</div>
                </th>
                <th>
                  <div>Total</div>
                </th>
                <th>
                  <FiltroMultiple
                    label="Contacto"
                    field="contacto"
                    options={options.contacto}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </th>

                <th>
                  <FiltroMultiple
                    label="Estatus"
                    field="estatus"
                    options={options.estatus}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </th>

                <th>
                  <FiltroMultiple
                    label="Mensaje"
                    field="mensajes"
                    options={options.mensajes}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                    transformValue={Number}
                  />
                </th>

                <th>
                  <FiltroMultiple
                    label="Facturado"
                    field="facturado"
                    options={options.facturado}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </th>
                <th>
                  <div>Cupon</div>
                </th>
                <th>
                  <div>Comentarios</div>
                </th>
              </tr>
            </thead>
            {datosFiltrados && datosFiltrados.length > 0 && (
              <>
                <tbody>
                  {/* Usar map para renderizar las filas de la tabla */}
                  {datosFiltrados.map((item, index) => (
                    <tr>
                      {/* <td className='row-icon'>{renderIcon("garantia")}</td> */}
                      <td className="sticky-chat-whatsapp">
                        <div
                          // className={
                          //   item.whatsapp === "Sin registrar"
                          //     ? "boton-chat-whatsapp-sin-numero"
                          //     : "boton-chat-whatsapp"
                          // }
                          className={
                            esTelefonoValido(item.whatsapp)
                              ? "boton-chat-whatsapp"
                              : "boton-chat-whatsapp-sin-numero"
                          }
                          // onClick={() => onGeneraPDF(co.folio)}
                          onClick={
                            esTelefonoValido(item.whatsapp)
                              ? () =>
                                handleOpenModalChat(item.whatsapp, item.cliente)
                              : undefined
                          }
                        >
                          <WhatsAppIcon />
                        </div>
                      </td>
                      <td
                        className={
                          item.tiene_orden === "S"
                            ? "sticky-folio celda-folio"
                            : "sticky-folio "
                        }
                        onClick={() =>
                          onVerOrden(item.orden, item.cliente, item.tiene_orden)
                        }
                      >
                        {item.orden}
                      </td>
                      <td className="sticky-cliente celda-cliente">
                        {capitalizePalabras(item.cliente)}
                      </td>
                      <td className="celda-sucursal">
                        {capitalizePalabras(item.sucursal)}
                      </td>
                      <td className="celda-vendedor">
                        {capitalizePalabras(item.vendedor)}
                      </td>
                      <td className="celda-vendedor">
                        {capitalizePalabras(item.vendedor)}
                      </td>
                      <td className="ta-center">{item.fecha}</td>
                      <td className="ta-right">{FormatMoney(item.total, 2)}</td>
                      <td className="celda-whatsapp">
                        {/* {item.whatsapp} */}
                        <div className="whatsapp">
                          {item.whatsapp === "Sin registrar" ? (
                            <div
                              className="boton-agregar-contacto"
                              onClick={() =>
                                handleOpenModalContacto(
                                  item.idcliente,
                                  item.orden,
                                )
                              }
                            >
                              <AddCircleOutlineIcon /> Agregar
                            </div>
                          ) : (
                            <div
                              className={
                                esTelefonoValido(item.whatsapp)
                                  ? "editar-numero"
                                  : "editar-numero-error"
                              }
                            // className="editar-numero"
                            >
                              {item.whatsapp}
                              <span
                                onClick={() =>
                                  handleOpenModalContacto(
                                    item.idcliente,
                                    item.orden,
                                  )
                                }
                              >
                                <EditIcon />
                              </span>
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="celda-estatus">{item.estado}</td>
                      <td className="ta-center">{item.mensajes_enviados}</td>
                      <td className="ta-center">
                        {item.facturado === "S" ? (
                          <CheckCircleIcon sx={{ color: "#5aa05b !important" }} />
                        ) : (
                          <RemoveCircleIcon
                            sx={{ color: "#7b7b7b !important" }}
                          />
                        )}
                      </td>
                      <td className="ta-center celda-cupon">
                        {item.cupon}
                      </td>
                      <td className="celda-comentario">
                        <div className="contenido-flex">
                          <div
                            // className={`boton-detalle-cotizaciones ${puedeEditar ? "" : "inhabilitado"}`}
                            onClick={() =>
                              handleOpenModalComentarios(item.orden, item.fecha)
                            }
                          >
                            <CommentIcon />
                          </div>
                          <span className="comentario-texto">
                            <label>{item.comentario}</label>
                            <br />
                            {item.creador_comentario && (
                              <span>
                                Creado por: {item.creador_comentario} - el{" "}
                                {item.fecha_comentario}
                              </span>
                            )}
                          </span>
                        </div>
                      </td>
                      {/* <td className='ta-center'><CheckCircleIcon sx={{ color: "#5aa05b !important" }} /></td>
                                            <td className='ta-center'><RemoveCircleIcon sx={{ color: "#7b7b7b !important" }} /></td> */}
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td className="ta-right"></td>
                    <td className="ta-right"></td>
                    <td className="ta-right"></td>
                    <td className="ta-right"></td>
                    <td className="ta-right"></td>
                    <td className="ta-center">{/* Total: */}</td>
                    <td className="ta-right">{/* {2000} */}</td>
                    <td className="ta-right">
                      {FormatMoney(totalCotizacion, 2)}
                    </td>
                    <td className="ta-center">Registros:</td>
                    <td className="ta-center">
                      {/* {FormatMoney(totalInteresMoratorio, 2)} */}
                      {datosFiltrados?.length}
                    </td>
                    <td className="ta-right"></td>
                    <td className="ta-right" colSpan={6}></td>
                  </tr>
                </tfoot>
              </>
            )}
          </table>
        </div>
      </div>

      <ModalComentariosTimeline
        open={openModalComentarios}
        onClose={handleCloseModalComentarios}
        folio={folioSelected}
        fecha={fechaRecordatorio}
        tipo={"CO"}
        update={onUpdate}
      />
      <ChatScreen
        open={modalChat}
        onClose={handleCloseModalChat}
        numeroTelefono={telefonoContacto}
        cliente={cliente}
        modulo={"POSVENTA"}
      />
    </PlantillaScreen>
  );
};
